import {
    ChoiceSpec,
    MultiSelectQuestion,
    SingleSelectQuestion,
    WritingQuestion,
} from '../../../../../commonv3/types/writingQuestions';
import { action, observable } from 'mobx';
import _ from 'lodash';

interface BaseAnswerState {
    isCorrect(): boolean;
}

export class SingleSelectAnswerState implements BaseAnswerState {
    @observable question: SingleSelectQuestion = null;
    @observable selectedOptionId: string = null;

    selectOption(choice: ChoiceSpec) {
        this.selectedOptionId = choice.id;
    }

    isSelected(choice) {
        return this.selectedOptionId === choice.id;
    }

    @action.bound
    init(question) {
        this.question = question;
        this.selectedOptionId = null;
    }

    isCorrect() {
        if (!this.question) {
            return false;
        }
        return this.question.content.choices.find((c) => c.answer && this.selectedOptionId === c.id) != null;
    }
}

export class MultiSelectAnswerState implements BaseAnswerState {
    @observable question: MultiSelectQuestion = null;
    @observable selectedOptionIds: string[] = [];

    selectOption(choice: ChoiceSpec) {
        if (this.selectedOptionIds.includes(choice.id)) {
            this.selectedOptionIds = this.selectedOptionIds.filter((id) => id !== choice.id);
        } else {
            this.selectedOptionIds = [...this.selectedOptionIds, choice.id];
        }
    }

    isSelected(choice) {
        return this.selectedOptionIds.includes(choice.id);
    }

    @action.bound
    init(question) {
        this.question = question;
        this.selectedOptionIds = [];
    }

    isCorrect(): boolean {
        if (!this.question) {
            return false;
        }
        return _.isEqual(
            new Set(this.question.content.choices.filter((c) => c.answer).map((c) => c.id)),
            new Set(this.selectedOptionIds)
        );
    }
}

export type QuestionAnswerState = MultiSelectAnswerState | SingleSelectAnswerState;
